import Vue from 'vue'
import Vuex from 'vuex'
import qs from 'qs'
import router from '@/router'
import VueJWT from 'vuejs-jwt'
import authService from '../services/authService'
/* eslint-disable */
import { createAsyncMutations } from '../stores/mutation-types'
import { doAsync, authAsync } from '../stores/async-util'
import types from '../stores/types'
import { TokenService, modules } from '@microbadevs/library'

Vue.use(Vuex)
Vue.use(VueJWT)

const state = {
  user: null,
  auth: Vue.$jwt.decode(localStorage.getItem('access_token')),
  isLoggedIn: authService.isLoggedIn(),
  dashboard: null,
  userKits: null,
  userSurveys: null,
}
const getToken = createAsyncMutations(types.GET_TOKEN, state)
const postLogin = createAsyncMutations(types.POST_LOGIN, state)
const postRefresh= createAsyncMutations(types.POST_REFRESH, state)
const getUserMutations = createAsyncMutations(types.GET_USER, state)
const getHCPMutations = createAsyncMutations(types.GET_HCP, state)
const postUserMutations = createAsyncMutations(types.POST_USER, state)
const putUserMutations = createAsyncMutations(types.PUT_USER, state)
const patchUserMutations = createAsyncMutations(types.PATCH_USER, state)
const getResetPassword = createAsyncMutations(types.GET_RESET_PASSWORD, state)
const postResetPassword = createAsyncMutations(types.POST_RESET_PASSWORD, state)
const postEmailVerification = createAsyncMutations(types.POST_EMAIL_VERIFICATION, state)
const kitMutations = createAsyncMutations(types.GET_KITS, state)
const compKitMutations = createAsyncMutations(types.GET_COMP_KITS_WITH_RESULTS, state)


const authMutations = {

  LOGIN_SUCCESS (state) {
    state.isLoggedIn = true
    state.pending = false
    router.push('profile')
  },
  LOGOUT (state) {
    console.log('LOGOUT LOGOUT')
    state.isLoggedIn = false
    router.push('/')
  }
}

const actions = {

  getToken: (context, username) => {
    doAsync(context, {
      url: 'auth/token?username=' + username,
      mutationType: types.GET_TOKEN
    }).then(response => {
      authService.setAccessTokenExpiration(response.data.expires_in)
      authService.setAccessToken(response.data.access_token)
      authService.setRefreshToken(response.data.refresh_token)
      TokenService.updateTokenDetails(response.data?.access_token, response.data?.refresh_token)
      Vue.set(state, 'user', response.data.user_id)
      window.location.reload()
    }).catch(error => {
      console.log(error)
    })
  },

  login: async (context, payload) => {
    const response = await authAsync(context, {
      url: 'oauth/token',
      mutationType: types.POST_LOGIN,
      method: 'POST',
      data: qs.stringify({
        grant_type: 'password',
        username: payload.email,
        password: payload.password,
        client_id: process.env.VUE_APP_API_USER,
      })
    })
    if (response.data.authorities.includes('ROLE_HCP')) {
      authService.setAccessTokenExpiration(response.data.expires_in)
      authService.setAccessToken(response.data.access_token)
      authService.setRefreshToken(response.data.refresh_token)
      TokenService.updateTokenDetails(response.data?.access_token, response.data?.refresh_token)
      Vue.set(state, 'user', response.data.user_id)
      router.push('dashboard')
    } else {
      const error = new Error()
      error.response = {data: {error_description: 'Unauthorised Access'}}
      throw error
    }
  },

  refreshToken: (context, payload) => {
    authAsync(context, {
      url: 'oauth/refresh',
      mutationType: types.GET_DASHBOARD,
      method: 'POST',
      data: qs.stringify({
        grant_type: 'password',
        username: payload.email,
        password: payload.password,
        client_id: process.env.VUE_APP_API_USER,
      }),
      postSuccess: (data) => {
        authService.setAccessTokenExpiration(data.expires_in)
        authService.setAccessToken(data.access_token)
      }
    })
  },

  logout: context => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('vuex')
    window.location.reload(false)
    context.commit('LOGOUT')
  },

  getDashboard: context => {
    authService.getUserID()
    return doAsync(context, {
      url: 'user/' + authService.getUserID() + '/dashboard',
      mutationType: types.GET_DASHBOARD
    })
  },

  getUser: (context) => {
    return doAsync(context, {
      url: 'user/' + authService.getUserID(),
      mutationType: types.GET_USER
    })
  },

  putUser: (context, data) => {
    const user = data
    if (user.password === null || user.newPassword === null) {
      delete user.password
      delete user.newPassword
    }
    return doAsync(context, {
      url: 'user/' + authService.getUserID(),
      method: 'PUT',
      mutationType: types.PUT_USER,
      data: user
    })
  },

  patchUser: (context, data) => {
    const user = data
    return doAsync(context, {
      url: 'user/' + user.id,
      method: 'PATCH',
      mutationType: types.PATCH_USER,
      data: user
    })
  },

  getPasswordReset: (context, email) => {
    return doAsync(context, {
      url: `/public/reset-password?username=${email}&user-type=HEALTH_CARE_PRACTITIONER`,
      mutationType: types.GET_RESET_PASSWORD
    })
  },

  postPasswordReset: (context, payload) => {
    return doAsync(context, {
      url: '/public/reset-password',
      method: 'POST',
      mutationType: types.POST_RESET_PASSWORD,
      data: payload
    })
  },

  getHCP: (context) => {
    return doAsync(context, {
      url: 'health-care-practitioner/' + authService.getHCPID(),
      mutationType: types.GET_HCP
    })
  },

  getKits: context => {
    return doAsync(context, {
      url: 'health-care-practitioner/' +authService.getHCPID() + '/kits',
      mutationType: types.GET_KITS
    })
  },

  getKitsWithResults: context => {
    return doAsync(context, {
      url: 'health-care-practitioner/' +authService.getHCPID() + '/kits?results-available=1',
      mutationType: types.GET_KITS_WITH_RESULTS
    })
  },

  getComplementary: context => {
    return doAsync(context, {
      url: 'health-care-practitioner/' + authService.getHCPID() + '/complementary-kits',
      mutationType: types.GET_COMP_KITS_WITH_RESULTS
    })
  },

  invitePatient: (context, payload) => {
    return doAsync(context, {
      url: 'health-care-practitioner/' + authService.getHCPID() + '/referral',
      method: 'POST',
      data: payload
    })
  },

  transferKit: (context, payload) => {
    return doAsync(context, {
      url: 'kit/' + payload.kitId + '/voucher-code?to=' + payload.email + '&first-name=' + payload.firstName + '&last-name=' + payload.lastName,
      method: 'POST',
      data: payload
    })
  },

  putPractice: (context, payload) => {
    return doAsync(context, {
      url: 'health-care-practitioner/' + authService.getHCPID(),
      method: 'PUT',
      data: payload
    })
  },

}

export default new Vuex.Store({
  state,
  modules: {
    maintenance: modules.maintenance,
    siteWideAlert: modules.siteWideAlert
  },
  mutations: {
    ...postLogin,
    ...postRefresh,
    ...putUserMutations,
    ...postUserMutations,
    ...patchUserMutations,
    ...getUserMutations,
    ...getHCPMutations,
    ...getResetPassword,
    ...postResetPassword,
    ...postEmailVerification,
    ...kitMutations,
    ...compKitMutations,
    ...authMutations,
    ...getToken
  },
  actions
})

